import { METADATA } from '../constants/metadata';
import { KNOWLEDGE_TITLE, KNOWLEDGE_URL } from '../constants/page';
import type { IArticle } from '../interfaces/IArticle';
import type IProductParams from '../interfaces/IProductParams';

import { getProductByAlias } from './getProductByAlias';

interface IParam {
  productInfo: IProductParams;
  asPath: string;
  productAlias?: string;
}
export const getGuideBreadcrumbs = ({ productInfo, productAlias, asPath }: IParam) => {
  const isBank = productAlias === 'banki';
  const isEnciklopediya = productAlias === 'enciklopediya' || productInfo?.category === 'enciklopediya';

  const enciklopediyaData = [{ url: asPath, title: 'Путеводитель по энциклопедии' }];

  if (!productInfo) {
    if (isEnciklopediya) {
      return enciklopediyaData;
    }

    return [
      { url: isBank ? `/banki/` : `/strakhovki/`, title: isBank ? 'Банки' : 'Страховки' },
      { url: asPath, title: METADATA.other.title },
    ];
  }

  if (isEnciklopediya) {
    return enciklopediyaData;
  }

  return [
    { url: productAlias ? productInfo.url : '/', title: productInfo.description },
    { url: asPath, title: 'Путеводитель' },
  ];
};

interface IArticleParams {
  article: IArticle;
  asPath: string;
  productAlias?: string;
}

export const getArticleBreadcrumbs = ({ article, asPath, productAlias }: IArticleParams) => {
  if (article) {
    if (productAlias === 'enciklopediya') {
      const crumbs = [{ url: KNOWLEDGE_URL, title: KNOWLEDGE_TITLE }];
      if (article.category.alias === 'enciklopediya') {
        crumbs.push({ url: `${KNOWLEDGE_URL}${article.subcategory.alias}/`, title: article.subcategory.name });
      } else {
        crumbs.push({ url: `${KNOWLEDGE_URL}${article.category.alias}/`, title: article.category.name });
        crumbs.push({
          url: `${KNOWLEDGE_URL}${article.category.alias}/${article.subcategory.alias}/`,
          title: article.subcategory.name,
        });
      }

      crumbs.push({ url: asPath, title: article.heading });
      return crumbs;
    }

    const productInfo = getProductByAlias(productAlias);
    const crumbs = [];

    crumbs.push({
      url: productAlias ? productInfo?.url || `/${article.subcategory.alias}/` : '/',
      title: productInfo?.description || article.subcategory.name,
    });

    crumbs.push({ url: `/${productAlias ? `${productAlias}/` : ''}info/`, title: 'Путеводитель' });
    crumbs.push({ url: asPath, title: article.heading });

    return crumbs;
  }

  return [];
};
